import React from 'react';

import { Label } from 'shadcn/components/ui/Label';
import { Switch } from 'shadcn/components/ui/Switch';
import { cn } from 'shadcn/lib/utils';

/**
 * Toggle for showing only bulk-upload rows that have validation issues, warnings, pending edits, or domain-specific flags.
 * Render only when `useBulkUpload` `showIssuesRowFilter` is true (at least one issue row). Wired to `showIssuesOnly` / `setShowIssuesOnly`; use `showIssuesFilterHint` for the filtered-view info alert. Does not trigger refetches.
 */
export function BulkUploadRowFilterSwitch({
    checked,
    className,
    disabled,
    id = 'bulk-upload-show-issues-only',
    onCheckedChange,
}) {
    return (
        <div className={cn('flex items-center gap-2', className)}>
            <Switch checked={checked} disabled={disabled} id={id} onCheckedChange={onCheckedChange} />
            <Label className="cursor-pointer text-sm font-normal leading-none" htmlFor={id}>
                Show only rows with issues
            </Label>
        </div>
    );
}
